import { combineReducers } from "redux";
import country from "../features/admin/masters/country/Slice";
import state from "../features/admin/masters/state/Slice";
import city from "../features/admin/masters/city/Slice";
import policy_agreement from "../features/admin/masters/policy_agreement/Slice";
import risk_disclosure from "../features/admin/masters/risk_disclosure/Slice";
import complaint_handling_policy from "../features/admin/masters/complaint_handling_policy/Slice";
import legal_document from "../features/admin/masters/legal_document/Slice";
import security_instruction from "../features/admin/masters/security_instruction/Slice";
import preventing_money_laundering from "../features/admin/masters/preventing_money_laundering/Slice";
import market_news from "../features/admin/masters/market_news/Slice";
import learn_more from "../features/admin/masters/learn_more/Slice";

const masters = combineReducers({
  country: country,
  state: state,
  city: city,
  learn_more: learn_more,
  policy_agreement: policy_agreement,
  risk_disclosure: risk_disclosure,
  complaint_handling_policy: complaint_handling_policy,
  legal_document: legal_document,
  security_instruction: security_instruction,
  preventing_money_laundering: preventing_money_laundering,
  market_news: market_news,
});

export default masters;
